import Controller from '@ember/controller'
import { tracked } from '@glimmer/tracking'

export class ReStandardsPerformanceController extends Controller {
  queryParams = ['contentLevel', 'sort', 'pageNumber', 'perPage']

  @tracked contentLevel = 'all'

  @tracked sort = 'lesson'

  @tracked pageNumber = 1

  @tracked perPage = 25
}

export default ReStandardsPerformanceController
